export default __webpack_public_path__ + "static/sprite_janssen-2f9a0ab5bd3dc227bc69fa65ec4d97b7.svg";